import store from '@/store'
import Time from '@/components/mixins/Time'

export default {
  mixins: [
    Time
  ],

  computed: {
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    sessionDetails () {
      return store.getters['getSessionDetails']
    },
    lastLogin () {
      return this.sessionDetails && this.sessionDetails.lastlogin && (new Date(this.sessionDetails.lastlogin)).toLocaleString()
    },
    loginTime () {
      return store.getters['getLoginTime'] || Date.now()
    }
  },

  methods: {
  },

  created () {
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Session.js